import React, { useState } from 'react';
import { Form, Card, Col, Row, Container, Button, Alert } from 'react-bootstrap';
import { auth } from '../config/db'; 
import { sendPasswordResetEmail } from 'firebase/auth';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Password reset email sent. Check your inbox.');
      setError('');
    } catch (err) {
      setMessage('');
      setError('Failed to send password reset email. Please try again.');
    }
  };

  return (
    <Container className="h-screen flex justify-center items-center">
      <Row className="w-full justify-center">
        <Col >
          <Card className="shadow-lg rounded-lg w-full">
            <Card.Body>
              <h2 className="text-center text-xl ">Przypomnij hasło</h2>
              {message && <Alert variant="success">{message}</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleResetPassword}>
                <Form.Group className="mb-3">
                  <Form.Label>Adres Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Wpisz swój email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button type="submit" className="w-full" variant="primary">
                  Wyślij link resetujący
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ForgotPassword;
